import React from 'react';
import proptypes from 'prop-types';
const {
  shape,
  node,
  string,
  bool
} = proptypes;
import { RedirectContext } from "./RedirectContext.js";
export const RedirectProvider = props => {
  const {
    children
  } = props;
  return /*#__PURE__*/React.createElement(RedirectContext.Provider, {
    value: props
  }, children);
};
RedirectProvider.propTypes = {
  children: node.isRequired
};
RedirectProvider.defaultProps = {};
//# sourceMappingURL=RedirectorProvider.js.map